window.rhm = window.rhm || {};
window.rhm.dom = window.rhm.dom || {};

window.rhm.dom.resolveElement = function (input) {
  if (!input) return null;
  if (input.nodeType === 1) return input;
  if (typeof input === 'string') return document.querySelector(input);
  return null;
};

window.rhm.dom.resolveElements = function (input) {
  if (!input) return [];
  if (typeof input === 'string') {
    return Array.prototype.slice.call(document.querySelectorAll(input));
  }
  if (input.nodeType === 1) return [input];
  if (typeof input.length === 'number' && typeof input.item === 'function') {
    return Array.prototype.slice.call(input);
  }
  return [];
};
